import Utils from 'general/utils/Utils';
import axiosClient from './axiosClient';

const chargeTransactionApi = {
  // lay danh sach phien sac
  getChargeTransactionList: (params) => {
    const url = '/ct';
    return axiosClient.get(url, {
      params: Utils.filterParams({
        exclusionZeroCost: true,
        ...params,
      }),
    });
  },

  // lay thong tin chi tiet phien sac
  getChargeTransactionDetail: (chargeTransactionId) => {
    const url = `/ct/${chargeTransactionId}`;
    return axiosClient.get(url);
  },

  updateOdo: (transactionId, body) => {
    const url = `/ct/updateOdo/${transactionId}`;
    return axiosClient.put(url, body);
  },
};

export default chargeTransactionApi;
